import styled from "styled-components";
import { GameTitleDefaultBox } from "./game-title.default.box";

export const GameTitleSICisBox = styled(GameTitleDefaultBox)`
    ${({theme}) => theme.font.presets.light};        

    @media ${({ theme }) => theme.mediaQuery.sAndBelow} {
        font-size: 12px;
        padding-bottom: 3px;
    }
`
